import styled from "styled-components"

const Image = styled.img`
     display: ${props => props.hideMobile ? 'none' : 'block'};

     ${props => props.round && `border-radius:50%;`}
     ${props => props.size ? `width:${props.size};height:${props.size};` : `width:3.5rem;height:3.5rem;`}
     ${props => props.margin && `margin:${props.margin};`}
          
     ${props => props.height && `height:${props.height};`}
     ${props => props.width && `width:${props.width};`}
     
`

export default Image